import React from 'react';
import '../../../node_modules/react-vis/dist/style.css';
import {
  XYPlot,
  XAxis,
  YAxis,
  HorizontalGridLines,
  VerticalGridLines,
  LineSeries,
  DiscreteColorLegend
} from 'react-vis';

class LineChart extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      chartName: 'Annual hourly flows'
    };
  }

  formatData = () => {
    let legendItems = [];
    let diagramData = [];
    let yDomain = [0];
    let seriesMax = [];
    let chartData = this.props.projectData.annual_hourly_flows;

    if (chartData) {
      chartData.forEach((series, j) => {
        let seriesData = [];
        series.values.forEach((value, i) => {
          seriesData.push({ x: i + 1, y: Number(value) })
        })
        legendItems.push(series.type);
        seriesMax.push(seriesData.reduce((max, p) => p.y > max ? p.y : max, seriesData[0].y))
        diagramData.push(seriesData);
      })
      yDomain.push(Math.ceil(seriesMax.reduce((max, p) => p > max ? p : max, seriesMax[0])) + 5);
    } else {
      let xValue = 0;
      while(xValue !== 24) {
        xValue += 1
        diagramData.push([{x: xValue, y: 0}])
      }
      diagramData.push([{x: xValue, y: 0}])
      yDomain.push(5)
    }
    
    return [diagramData, legendItems, yDomain];
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.forceUpdate()
    });
  }

  render() {
    const data = this.formatData()[0];
    const legendItems = this.formatData()[1];
    const yDomain = this.formatData()[2];
    const time = [
      '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
      '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
    ];
    let width = this.props.show ? ((window.innerWidth - (this.props.size + 350)) - 150 ) : ((window.innerWidth - this.props.size)) - 200
    width = this.props.size === null ? window.innerWidth / 2 - 370 : width
    return (
      <div className='chart-container'>
        <h5>{this.state.chartName}</h5>
        <div className='chart'>
          <XYPlot width={width - 100} height={400} yDomain={yDomain}>
            <HorizontalGridLines />
            <VerticalGridLines />
            <XAxis title="Time" tickFormat={v => time[v]} />
            <YAxis title="Flowrate (l/s)" />
            {
              data.map((dataSeries, i) => {
                return (<LineSeries data={dataSeries} key={'series' + i} />);
              })
            }
          </XYPlot>
          <DiscreteColorLegend height={400} width={100} items={legendItems} />
        </div>
      </div>
    )
  }
}

export default LineChart